import { useState } from "react";
import { useTranslation } from "react-i18next";
import { css } from "../../../styled-system/css";
import { Button } from "../../components/core/basic/Button";
import type { ValidationItem } from "./alertUtils";

const DEFAULT_VISIBLE = 10;

export function ValidationList({ items }: { items: ValidationItem[] }) {
  const { t } = useTranslation(["uploads"]);
  const [expanded, setExpanded] = useState(false);

  const visibleItems = expanded ? items : items.slice(0, DEFAULT_VISIBLE);
  const hasMore = items.length > DEFAULT_VISIBLE;

  return (
    <div className={css({ width: "100%" })}>
      <div
        className={css({
          display: "grid",
          gap: "small",
          gridTemplateColumns: "80px 1fr 3fr",
          width: "100%",
          padding: "small",
        })}
      >
        <strong>{t(($) => $.uploads.alerts.Row)}</strong>
        <strong>{t(($) => $.uploads.alerts.Field)}</strong>
        <strong>{t(($) => $.uploads.alerts.Message)}</strong>
        {visibleItems.map((item, i) => (
          <div key={`${item.field}-${i}`} className={css({ display: "contents" })}>
            <span>{item.row === null ? "—" : `#${item.row + 1}`}</span>
            <span>{item.field}</span>
            <span>{item.message}</span>
          </div>
        ))}
      </div>
      {hasMore && !expanded && (
        <Button variant="contentOnly" onPress={() => setExpanded(true)} fontSize="small">
          {t(($) => $.uploads.alerts["Show all items"], { count: items.length })}
        </Button>
      )}
    </div>
  );
}
